import * as React from 'react';

import type { DataValueProps } from './DataValue.types';

import styles from './DataValue.module.css';

/**
 * Component responsible for displaying a value with a fallback for empty values (null, undefined, or empty string).
 * It applies a specific style to the fallback value for better visual distinction.
 */
const DataValue = React.memo(
  ({
    value,
    fallback = 'undefined',
  }: Readonly<DataValueProps>): React.ReactElement => {
    const isEmpty = value === null || value === undefined || value === '';

    return (
      <span
        className={isEmpty ? styles.fallback : undefined}
        data-testid="data-value"
      >
        {isEmpty ? fallback : value}
      </span>
    );
  }
);

DataValue.displayName = 'DataValue';

export { DataValue };
